import { Button, DialogContentText } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { useNotification } from '../../context/NotificationContext';
import api from '../../services/api';
import { TOKEN_USER } from '../../services/auth';
import colors from '../../styles/settings/colors';
import { handleErrorRequest } from '../../utils/errorsValidation';
import * as S from './styles';

let currentAnchor;
export function Notifications() {
  const {
    amountNotifications,
    anchorId,
    canShowNotification,
    fetchNotification,
    setAmountNotifications,
    setCanShowNotification,
    setFetchNotification,
  } = useNotification();
  const loginId = JSON.parse(sessionStorage.getItem(TOKEN_USER))?.loginId;
  const searchInput = useRef(null);

  const [currentlyMessage, setCurrentlyMessage] = useState({});
  const [indexMessage, setIndexMessage] = useState(0);
  const [intervalTime, setintervalTime] = useState(0);
  const [isInAction, setIsInAction] = useState(false);
  const [messageData, setMessageData] = useState([]);
  const [messages, setMessages] = useState([]);
  const [open, setOpen] = useState(false);
  const [updateContent, setUpdateContent] = useState(Date.now());

  const getEndpoint = ({ hasAnchor, canShow, isClickIcon }) => {
    const PRIORITY_SETTING = Number(
      JSON.parse(sessionStorage.getItem('@Capittale-Web-Setting'))?.configuracoesAmbienteWeb?.find(
        (el) => el.parametroId === 55,
      )?.valor ?? 0,
    );

    const isOperation = window.location.pathname === '/app/operacao-antecipacao';

    if (isClickIcon && !isOperation) {
      return `Notificacoes/ConsultarNaoVisualizados?ancoraId=0&loginId=${loginId}&ancoraEspecifico=false&prioridade=0`;
    }

    if (isClickIcon && isOperation) {
      return `Notificacoes/ConsultarNaoVisualizados?ancoraId=${anchorId}&loginId=${loginId}&ancoraEspecifico=false&prioridade=0`;
    }

    if (hasAnchor && anchorId && !canShow && isOperation) {
      return `Notificacoes/ConsultarNaoVisualizados?ancoraId=${anchorId}&loginId=${loginId}&ancoraEspecifico=false&prioridade=${PRIORITY_SETTING}`;
    }

    if (canShow && isOperation && hasAnchor) {
      return `Notificacoes/ConsultarNaoVisualizados?ancoraId=${anchorId}&loginId=${loginId}&ancoraEspecifico=false&prioridade=${PRIORITY_SETTING}`;
    }

    if (canShow && !isOperation && hasAnchor) {
      return `Notificacoes/ConsultarNaoVisualizados?ancoraId=${anchorId}&loginId=${loginId}&ancoraEspecifico=false&prioridade=0`;
    }

    return `Notificacoes/ConsultarNaoVisualizados?ancoraId=0&loginId=${loginId}&ancoraEspecifico=false&prioridade=0`;
  };

  const readNotification = async ({ param }) => {
    setIsInAction(true);
    try {
      await api.put('Notificacoes/AtualizarComoVisualizado', {
        ...currentlyMessage?.referencia,
        tipoBaixa: param,
      });
      setIsInAction(false);
      checkNextMessage();
    } catch (error) {
      handleErrorRequest(error);
      setIsInAction(false);
    }
  };

  const handleClickButton = ({ type }) => {
    switch (type) {
      case 'READ_NOTIFICATION':
        setAmountNotifications(amountNotifications - 1);
        readNotification({ param: 'visualizado' });
        break;
      case 'RESCHEDULE_NOTIFICATION':
        readNotification({ param: 'reagendado' });
        break;
      case 'POST_PONE_NOTIFICATION':
        readNotification({ param: 'adiado' });
        break;
      default:
        break;
    }
  };

  const fetchNotifications = async (hasAnchor, canShow = false, isClickIcon = false) => {
    const endpoint = getEndpoint({ hasAnchor, canShow, isClickIcon });

    try {
      const response = await api.get(endpoint);
      if (response.data.status !== 'Inconsistencia') {
        setMessageData(response?.data?.complemento?.mensagensBox);
        setAmountNotifications(response?.data?.resposta?.quantidadeDeNotificacoes);

        if (canShow && response?.data?.complemento?.mensagensBox.length > 0) {
          setCanShowNotification(true);
          setOpen(true);
        }
      } else {
        handleErrorRequest(response);
      }
    } catch (error) {
      handleErrorRequest(error.response);
    }
    // setFetchNotification(false);
  };

  const fetchCount = async (hasAnchor) => {
    const PRIORITY_SETTING = Number(
      JSON.parse(sessionStorage.getItem('@Capittale-Web-Setting'))?.configuracoesAmbienteWeb?.find(
        (el) => el.parametroId === 55,
      )?.valor ?? 0,
    );

    let endpoint = `Notificacoes/ConsultarQuantidadeNaoVisualizados?ancoraId=0&loginId=${loginId}&ancoraEspecifico=false&prioridade=0`;
    if (hasAnchor && anchorId) {
      endpoint = `Notificacoes/ConsultarQuantidadeNaoVisualizados?ancoraId=${anchorId}&loginId=${loginId}&ancoraEspecifico=false&prioridade=${PRIORITY_SETTING}`;
    }

    try {
      const response = await api.get(endpoint);
      if (response.data.status !== 'Inconsistencia') {
        setAmountNotifications(response?.data?.resposta?.quantidadeDeNotificacoes);
        if (
          window.location.pathname === '/app/operacao-antecipacao' &&
          response?.data?.resposta?.quantidadeDeNotificacoesPrioritarias > 0
        ) {
          fetchNotifications(window.location.pathname === '/app/operacao-antecipacao', true);
        }
      } else {
        handleErrorRequest(response);
      }
    } catch (error) {
      handleErrorRequest(error.response);
    }
    setFetchNotification(false);
  };

  const checkNextMessage = () => {
    if (messages?.length > indexMessage + 1) {
      setOpen(false);
      setTimeout(() => {
        setIndexMessage((prevIndex) => prevIndex + 1);
        setCurrentlyMessage(messages[indexMessage + 1]);
        setOpen(true);
      }, 500);
      return;
    }
    setOpen(false);
  };

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') {
      return;
    }

    checkNextMessage();
  };

  const checkAutoClose = () => {
    if (currentlyMessage.fecharAutomaticamente > 0) {
      setTimeout(() => {
        handleClose();
      }, currentlyMessage.fecharAutomaticamente * 1000);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      searchInput?.current?.focus?.();
    }, 200);
    if (messageData?.length > 0) {
      checkAutoClose();
      setMessages(messageData);
      setCurrentlyMessage(messageData?.[0]);
      setIndexMessage(0);
      setOpen(true);
    }
  }, [messageData]);

  useEffect(() => {
    if (fetchNotification) {
      setCanShowNotification(true);
      fetchNotifications(window.location.pathname === '/app/operacao-antecipacao', true, true);
      setFetchNotification(false);
    }
  }, [fetchNotification, window.location.pathname]);

  useEffect(() => {
    if (window.location.pathname === '/app/operacao-antecipacao') {
      fetchCount(window.location.pathname === '/app/operacao-antecipacao');
    }
  }, [updateContent]);

  useEffect(() => {
    if (anchorId && anchorId !== currentAnchor) {
      fetchCount(window.location.pathname === '/app/operacao-antecipacao');
      currentAnchor = anchorId;
    }
  }, [anchorId, window.location.pathname]);

  useEffect(() => {
    if (intervalTime > 0) {
      const interval = setInterval(() => setUpdateContent(+new Date()), intervalTime);
      return () => {
        clearInterval(interval);
      };
    }
  }, [intervalTime]);

  useEffect(() => {
    fetchCount(window.location.pathname === '/app/operacao-antecipacao');
    if (window.location.pathname === '/app/operacao-antecipacao') {
      const INTERVAL_TIME_SETTING =
        JSON.parse(
          sessionStorage.getItem('@Capittale-Web-Setting'),
        )?.configuracoesAmbienteWeb?.find((el) => el.parametroId === 54)?.valor ?? 0;

      const INTERVAL_TIME_FORMATED = INTERVAL_TIME_SETTING * 1000 * 60;
      setintervalTime(INTERVAL_TIME_FORMATED);
    }
  }, [window.location.pathname]);

  return (
    <S.DialogModal
      open={open && canShowNotification}
      onClose={handleClose}
      disableEscapeKeyDown
      className="dialog-parent"
      widthContainer={currentlyMessage?.mensagemBoxLargura}
    >
      <S.DialogContainer borderColor={currentlyMessage?.tituloCorDeFundo}>
        <div className="margin-container">
          <S.Title
            bgColor={currentlyMessage?.tituloCorDeFundo}
            color={currentlyMessage?.tituloCorDaFonte}
            heightTitle={currentlyMessage?.TituloBoxAltura}
            style={{
              height: `${
                currentlyMessage?.tituloBoxAltura > 0
                  ? `${currentlyMessage?.tituloBoxAltura}${currentlyMessage?.mensagemBoxUnidade}`
                  : 'auto'
              }`,
            }}
            fontTitle={currentlyMessage?.tituloTamanhoDaFonte}
          >
            <span dangerouslySetInnerHTML={{ __html: currentlyMessage?.tituloTexto }}></span>
          </S.Title>

          <S.BodyText
            bgColor={currentlyMessage?.mensagemCorDeFundo}
            color={currentlyMessage?.mensagemCorDaFonte}
            messageFontSize={currentlyMessage?.mensagemTamanhoDaFonte}
            style={{
              height: `${
                currentlyMessage?.mensagemBoxAltura > 0
                  ? `${currentlyMessage?.mensagemBoxAltura}${currentlyMessage?.mensagemBoxUnidade}`
                  : 'auto'
              }`,
            }}
          >
            <DialogContentText>
              <div
                className="message-html"
                dangerouslySetInnerHTML={{ __html: currentlyMessage?.mensagemTexto }}
                style={{
                  textAlign: currentlyMessage?.mensagemTextoAlinhamento?.toLowerCase(),
                }}
              ></div>
            </DialogContentText>
          </S.BodyText>

          <S.DialogActionsMessage backgroundColor={currentlyMessage.barraBotoesCorDeFundo}>
            {currentlyMessage?.botao3Ativo && (
              <Button
                onClick={() =>
                  handleClickButton({
                    type: currentlyMessage?.botaoAction || 'RESCHEDULE_NOTIFICATION',
                  })
                }
                disabled={isInAction}
                style={{
                  backgroundColor: currentlyMessage.botao3CorDeFundo,
                  color: currentlyMessage.botao3CorDaFonte,
                  cursor: isInAction ? 'not-allowed' : 'pointer',
                  fontWeight: '400',
                  textTransform: 'initial',
                }}
              >
                {currentlyMessage?.botao3Texto}
              </Button>
            )}
            {currentlyMessage?.botao2Ativo && (
              <Button
                onClick={() =>
                  handleClickButton({
                    type: currentlyMessage?.botaoAction || 'POST_PONE_NOTIFICATION',
                  })
                }
                disabled={isInAction}
                style={{
                  backgroundColor: currentlyMessage.botao2CorDeFundo,
                  color: currentlyMessage.botao2CorDaFonte,
                  cursor: isInAction ? 'not-allowed' : 'pointer',
                  fontWeight: '400',
                  textTransform: 'initial',
                }}
              >
                {currentlyMessage?.botao2Texto}
              </Button>
            )}
            {currentlyMessage?.botao1Ativo && (
              <Button
                onClick={() =>
                  handleClickButton({
                    type: currentlyMessage?.botaoAction || 'READ_NOTIFICATION',
                  })
                }
                disabled={isInAction}
                autoFocus
                focusVisible
                ref={searchInput}
                style={{
                  backgroundColor: currentlyMessage?.botao1CorDeFundo || colors.sanMarino,
                  color: currentlyMessage?.botao1CorDaFonte || '#fff',
                  cursor: isInAction ? 'not-allowed' : 'pointer',
                  fontWeight: '400',
                  textTransform: 'initial',
                }}
              >
                {currentlyMessage?.botao1Texto || 'Fechar'}
              </Button>
            )}
          </S.DialogActionsMessage>
        </div>
      </S.DialogContainer>
    </S.DialogModal>
  );
}
